<template>
  <div class="distribution-date__area display-center">
    <div class="distribution-date__head custom-distribution-date__head">
      <div class="distribution-date__head-comment custom-height">
        <div class="distribution-date__head-comment-inner">
          <div class="distribution-date__head-comment-text">
            サブミット実施時 <br>
            本日 <span style="font-weight: 500;">{{ date }}</span> 配信審査申請をした場合
          </div>
        </div>
      </div>
      <div class="distribution-date__head-block">
        <div class="distribution-date">
          <div class="distribution-date__number custom-distribution-date__number">
            {{ getSubmitDate() }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'SubmitMinReleaseSchedules',

  data() {
    return {
      submitDay: 28,
      date: moment().format('M月D日'),
      minDate: null,
    }
  },
  async mounted() {
    await this.getSubmitDays()
  },
  methods: {
    // Get the date by adding the specified submit days to the current date.
    getSubmitDate() {
      return moment().add(this.submitDay, 'd').format('YYYY年MM月DD日')
    },
    async getSubmitDays() {
      const currentDate = moment().format('YYYY-MM-DD')
      const { data } = await window.axios.get('/api/client/submitDate/getDay', {
        params: {
          currentDate,
        },
      })
      this.submitDay = data
    },
  },
}
</script>
<style scoped>
.display-center {
  display: flex;
  align-items: center;
}
.custom-height {
  height: 96px !important;
}
.custom-distribution-date__head {
  display: flex;
  width: 100%;
  justify-content: center;
  min-width: 50%;
}
</style>
